export default __webpack_public_path__ + "assets/png/1b218ce74ea89797889302781c4373bb.png";